<script lang="ts">
    import { LL } from "../../../i18n/i18n-svelte";
    import { StringUtils } from "../../Utils/StringUtils";
    import Chip from "../UI/Chip.svelte";
    import { IconCheck, IconUnMute } from "@wa-icons";

    let editMode = $state(false);

    interface Props {
        selectedDevice?: string;
        deviceList: MediaDeviceInfo[];
        onplaysound?: (deviceId: string | undefined) => void;
        onselectdevice?: (deviceId: string | undefined) => void;
    }

    let { selectedDevice = undefined, deviceList, onplaysound, onselectdevice }: Props = $props();
</script>

<div
    class="w-full min-w-0 rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] p-4 text-[var(--nutrivera-shell-text)]"
>
    <div class="text-lg bold flex items-center justify-center gap-3 mb-4 ps-2">
        <IconUnMute font-size="28" />
        <div class="grow pe-8 ps-2">{$LL.camera.editSpeaker()}</div>
        <button
            class="nutrivera-entry-secondary px-3"
            onclick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                editMode = !editMode;
            }}
        >
            {!editMode ? $LL.actionbar.edit() : $LL.actionbar.cancel()}
        </button>
    </div>

    <div class="flex items-center justify-center w-full">
        <div class="flex flex-wrap items-center justify-center w-full">
            {#each deviceList as speaker, index (index)}
                <!-- svelte-ignore a11y_click_events_have_key_events -->
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <div
                    class="nutrivera-entry-option relative w-full cursor-pointer items-center justify-between space-x-4 overflow-hidden px-8 py-6"
                    class:flex={editMode || selectedDevice === speaker.deviceId}
                    class:hidden={!editMode && selectedDevice !== speaker.deviceId}
                    data-selected={selectedDevice === speaker.deviceId}
                    onclick={() => {
                        onselectdevice?.(speaker.deviceId);
                        onplaysound?.(speaker.deviceId);
                        editMode = false;
                    }}
                >
                    <div class="flex items-center space-x-4 overflow-hidden truncate">
                        <div
                            class="me-4 flex aspect-square h-6 items-center justify-center rounded-full border border-solid border-[var(--nutrivera-shell-border)] {selectedDevice ===
                            speaker.deviceId
                                ? 'border-[var(--nutrivera-shell-accent)] bg-[var(--nutrivera-shell-accent)]'
                                : ''}"
                        >
                            {#if selectedDevice === speaker.deviceId}
                                <IconCheck class="text-[var(--nutrivera-shell-accent-ink)]" />
                            {/if}
                        </div>
                        <div class="space-y-1 min-w-0">
                            <div class="text-lg bold truncate leading-tight">
                                {StringUtils.normalizeDeviceName(speaker.label)}
                            </div>
                            {#if selectedDevice === speaker.deviceId}
                                <Chip class="nutrivera-entry-muted">{$LL.camera.active()}</Chip>
                            {:else}
                                <Chip class="nutrivera-entry-muted">{$LL.camera.notRecommended()}</Chip>
                            {/if}
                        </div>
                    </div>
                    {#if selectedDevice === speaker.deviceId}
                        <button class="nutrivera-entry-secondary self-end px-3" type="button">
                            <!-- TODO HUGO -->
                            <IconUnMute font-size="20" />
                        </button>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
</div>
